module.exports={
	"Form": "ProjectTagTypeEditManifest",
	"Scope": "ProjectTagType-Edit",
	"Descriptors":
	{
		"ProjectTagTypeDetails.IDProjectTagType":
		{
			"Name": "ID",
			"Hash": "PTTEdit-ID",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 2,
				"Section": "PTTEditIdentity",
				"Group": "PTTEditIdentity"
			}
		},
		"ProjectTagTypeDetails.GUIDProjectTagType":
		{
			"Name": "GUID",
			"Hash": "PTTEdit-GUID",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 4,
				"Section": "PTTEditIdentity",
				"Group": "PTTEditIdentity"
			}
		},
		"ProjectTagTypeDetails.TagType":
		{
			"Name": "Tag Type",
			"Hash": "PTTEdit-TagType",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 3,
				"Section": "PTTEditIdentity",
				"Group": "PTTEditIdentity"
			}
		},
		"ProjectTagTypeDetails.Name":
		{
			"Name": "Display Name",
			"Hash": "PTTEdit-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 3,
				"Section": "PTTEditIdentity",
				"Group": "PTTEditIdentity"
			}
		},
		"ProjectTagTypeDetails.Ordinal":
		{
			"Name": "Ordinal",
			"Hash": "PTTEdit-Ordinal",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "Number",
				"Row": "2",
				"Width": 3,
				"Section": "PTTEditConfig",
				"Group": "PTTEditConfig"
			}
		},
		"ProjectTagTypeDetails.IDProject":
		{
			"Name": "Project ID",
			"Hash": "PTTEdit-IDProject",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "Number",
				"Row": "2",
				"Width": 3,
				"Section": "PTTEditConfig",
				"Group": "PTTEditConfig"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "PTTEditIdentity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "PTTEditIdentity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Configuration",
			"Hash": "PTTEditConfig",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Configuration",
					"Hash": "PTTEditConfig",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}
